import api from "!../../../../../../tmp/drone/cache/97ad1b110c8dd6cac94e781092a7d10b532529fd5be562952868a2a0c57f92a6/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../tmp/drone/cache/97ad1b110c8dd6cac94e781092a7d10b532529fd5be562952868a2a0c57f92a6/node_modules/css-loader/index.js??ruleSet[1].rules[1].use[1]!./yellowHiveCss.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};